import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import {
  getClassroomAvailabilityActionRequest,
  getNonStructuredSectionActionRequest,
  getNonStructuredSectionSchedulesActionRequest,
  updateNonStructuredSectionSchedulesActionRequest,
} from '../api';
import {
  NonStructuredSectionClassroomLoaderFilters,
  UpdateNonStructuredSectionSchedules,
} from '../types';

const getNonStructuredSectionAction = actionKitImpFunction(
  async (id: string | number) => {
    const response = await getNonStructuredSectionActionRequest(id);
    if (response.error) {
      return null;
    }

    const { data } = response;

    return data;
  },
);

const getNonStructuredSectionSchedulesAction = actionKitImpFunction(
  async (id: string | number) => {
    const response = await getNonStructuredSectionSchedulesActionRequest(id);
    if (response.error) {
      return null;
    }

    const { data } = response;

    return data;
  },
);

const updateNonStructuredSectionSchedulesAction = actionKitImpFunction(
  async (id: string | number, data: UpdateNonStructuredSectionSchedules) => {
    const response = await updateNonStructuredSectionSchedulesActionRequest(
      id,
      data,
    );
    if (response.error) {
      throw new Error('Error updating section schedules');
    }
    return response.data;
  },
);

const getClassroomAvailabilityAction = actionKitImpFunction(
  async (
    data: NonStructuredSectionClassroomLoaderFilters & {
      sectionId: number | string;
    },
  ) => {
    const response = await getClassroomAvailabilityActionRequest(data);
    if (response.error) {
      throw new Error('Error getting classroom availability');
    }
    return response.data;
  },
);

export {
  getNonStructuredSectionAction,
  getNonStructuredSectionSchedulesAction,
  updateNonStructuredSectionSchedulesAction,
  getClassroomAvailabilityAction,
};
